export const CLAIM_UTYPE = "YellowDuck:UserType";
export const CLAIM_UTYPE_USER = "User";
export const CLAIM_UTYPE_ADMIN = "Admin";
export const CLAIM_UTYPE_EDITOR = "Editor";
